// The signed-in user's own support tickets and feature requests.
import { createApi } from "@reduxjs/toolkit/query/react";
import { createCustomFetchBaseQuery } from "../baseQuery";

export const tickets = createApi({
  reducerPath: "tickets",
  baseQuery: createCustomFetchBaseQuery(),
  tagTypes: ["Tickets"],
  endpoints: (builder) => ({
    getMyTickets: builder.query({
      query: (type) => (type ? `/api/tickets?type=${type}` : "/api/tickets"),
      providesTags: ["Tickets"],
    }),
    getMyTicket: builder.query({
      query: (id) => `/api/tickets/${id}`,
      providesTags: (result, error, id) => [{ type: "Tickets", id }],
    }),
    createTicket: builder.mutation({
      query: (body) => ({ url: "/api/tickets", method: "POST", body }),
      invalidatesTags: ["Tickets"],
    }),
    replyMyTicket: builder.mutation({
      query: ({ id, message }) => ({ url: `/api/tickets/${id}/replies`, method: "POST", body: { message } }),
      invalidatesTags: (result, error, { id }) => ["Tickets", { type: "Tickets", id }],
    }),
  }),
});

export const {
  useGetMyTicketsQuery,
  useGetMyTicketQuery,
  useCreateTicketMutation,
  useReplyMyTicketMutation,
} = tickets;
